import { CreateGroupSourceMutationVariables } from 'api';

export const clientGroupSourceCreateResponse = ({
  group_id,
  source_type,
  source_status,
  source_value,
  approval,
}: CreateGroupSourceMutationVariables) => ({
  clientGroupSourceCreate: {
    group_id,
    source_type,
    source_status,
    source_value,
    approval,
    id: '-1',
    // @ts-ignore
    __typename: 'ClientGroupSource',
  },
});
